import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "m5.965 16.532-.004-.004-1.967-1.803a1.83 1.83 0 0 1-.112-2.586L6.586 9.19l.004-.004.004-.005.41-.448a2.95 2.95 0 0 1 2.768-.897l1.25.256a1.295 1.295 0 0 0 1.345-.563l.453-.696a2.198 2.198 0 1 1 3.196 2.93l-.654.512c-.42.327-.595.878-.444 1.388l.363 1.224c.295.994.046 2.07-.654 2.834l-3.123 3.406a1.83 1.83 0 0 1-2.585.113l-2.95-2.704zm1.027-6.294L4.624 12.82a.823.823 0 0 0 .05 1.162l1.6 1.467.561-.612a.504.504 0 0 1 .743.681l-.561.611 1.223 1.122 1.462-1.595a.504.504 0 0 1 .743.681l-1.462 1.595.616.565a.823.823 0 0 0 1.163-.05l2.367-2.583zm6.818 4.884L7.673 9.495l.074-.08a1.95 1.95 0 0 1 1.823-.592l1.25.255a2.3 2.3 0 0 0 2.391-1l.453-.696a1.19 1.19 0 1 1 1.732 1.588l-.655.511a2.3 2.3 0 0 0-.789 2.468l.363 1.224c.194.655.03 1.364-.43 1.868z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }